/*
  Only use this with legacy React class components
  use `useEngagementPermissions` with functional components
 */

import { useEngagementPermissions } from '../hooks/useEngagementPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
// also used in 'useEngagementPermissions'
export const getIsEngagementOwner = (engagement, currentOwnerId) => {
  const engagementOwnerId = engagement && engagement.getIn(['engagement', 'ownerId']);
  const isEngagementOwner = currentOwnerId === engagementOwnerId;
  return isEngagementOwner;
};
export const WithEngagementPermissions = Component => {
  const Wrapper = props => {
    const {
      engagement
    } = props;
    const canEdit = useEngagementPermissions({
      engagement
    });
    return /*#__PURE__*/_jsx(Component, Object.assign({
      canEdit: canEdit
    }, props));
  };
  Wrapper.displayName = 'WithEngagementPermissions';
  return Wrapper;
};